export default "__VITE_ASSET__29180b90__"